import * as React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LinkContainer } from "components/common";
import { Button, ButtonToolbar } from "components/bootstrap";
import SearchFiltersRoutes from "search-filter/Routes";
const SearchFilterPageSubactions = () => {
  const { filterId } = useParams();
  const { t } = useTranslation("enterprise_search");
  return /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: SearchFiltersRoutes.SHOW(filterId) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, t("search_filter_page_subactions.view_filter_and_usages"))), /* @__PURE__ */ React.createElement(LinkContainer, { to: SearchFiltersRoutes.EDIT(filterId) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, t("search_filter_page_subactions.edit_filter"))));
};
export default SearchFilterPageSubactions;
